import React from 'react';
import PropTypes from 'prop-types';
import { useForm, useFormState } from 'react-hook-form';
import CustomFormInput from '../forms/CustomFormInput';
import { Col, Form, FormLabel } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import * as yup from "yup";
import { yupResolver } from '@hookform/resolvers/yup';

// Define a validation schema for the form.
const schema = yup.object({
  name: yup.string().required().min(3),
  phone: yup.string().required(),
  email: yup.string().required().email(),  
}).required();

const AccountCompletionForm = ({ defaultValues, onSubmit, onError }) => {
  
  const { register, formState: { errors }, handleSubmit, control } = useForm({
    mode: "onChange",
    defaultValues: defaultValues,
    resolver: yupResolver(schema)
  });


  const { isValid, dirtyFields , isSubmitting } = useFormState({
    control
  });
  
  const { t } = useTranslation();  
  
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="row">
      
        
        <div className="col-xs-12 col-md-6 mb-3">

          <FormLabel className="fw-bold" htmlFor="name">{t('account:lblName')}<span
            className="requiredIndicator">*</span> </FormLabel>
          <CustomFormInput fieldName='name' 
            params={{ required: true }}
            register={register}         
            dirtyFields={dirtyFields}   
            errorMessage={errors?.name?.message} />          
        </div>


        <div className="col-xs-12 col-md-6 mb-3">

          <FormLabel className="fw-bold" htmlFor="email">{t('account:lblEmail')}<span
            className="requiredIndicator">*</span> </FormLabel>
          <CustomFormInput fieldName='email'
            params={{ required: true }}
            register={register}
            dirtyFields={dirtyFields}   
            errorMessage={errors?.email?.message} />          
        </div>
      </div>
      <div className="row">

        <div className="col-xs-12 col-md-6 mb-3">

          <FormLabel className="fw-bold" htmlFor="phone">{t('account:lblPhone')}<span
            className="requiredIndicator">*</span> </FormLabel>
          <CustomFormInput fieldName='phone'
            params={{ required: true }}
            register={register}
            dirtyFields={dirtyFields}   
            errorMessage={errors?.phone?.message} />          
        </div>
      </div>
      <Form.Group className="row">
        <Col>
          <button type="submit" id="btnSaveUser" color="primary" className="btn btn-success  mt-3 me-2"
            disabled={!isValid || isSubmitting}>
            {t('common:btnSubmit')}
          </button>
        </Col>
      </Form.Group>
    </form>
  );
};

AccountCompletionForm.propTypes = {
  defaultValues: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
};

export default AccountCompletionForm;